import { createApp } from 'vue'
import { createI18n } from 'vue-i18n'
import App from './App.vue'
import router from './router'
/* import 'default-passive-events' */
import axios from 'axios'
import Antd from 'ant-design-vue';
import { Modal, message } from "ant-design-vue";
import "ant-design-vue/dist/reset.css";
import VueUeditorWrap from 'vue-ueditor-wrap';
import mitt from 'mitt';

// 定义一个重新登录弹出窗的变量
var loginBack = false

const reloadCodes = [401, 410, 1011007, 1011008]

axios.defaults.baseURL = '/api'

// 设置请求拦截器
axios.interceptors.request.use((config) => {
  // 从本地存储中获取token信息
  const token = localStorage.getItem('token');
  // 如果存在token，则将token信息设置到请求头中
  if (token) {
    config.headers.Token = token;
  }
  return config;
}, (error) => {
  console.log("请求错误:", error)
  return Promise.reject(error);
});

const error = () => {
  loginBack = true
  Modal.error({
    title: '提示：',
    okText: '重新登录',
    content: '登录已失效， 请重新登录',
    onOk: () => {
      loginBack = false
      let lang = localStorage.getItem("lang");
      localStorage.clear();
      localStorage.setItem("lang", lang);
      window.location.reload()
    }
  })
}

axios.interceptors.response.use(
  (response) => {
    // 配置了blob，不处理直接返回文件流
    if (response.config.responseType === 'blob') {
      if (response.status === 200) {
        return response
      } else {
        message.warning('文件下载失败或此文件不存在')
        return
      }
    }
    const data = response.data
    const code = data.code
    if (reloadCodes.includes(code)) {
      if (!loginBack.value) {
        error()
      }
      return
    }
    return Promise.resolve(response)
  },
  (error) => {
    if (error) {
      console.log("响应错误:", error)
      if (error.code === 'ERR_NETWORK'){
         // 请求超时错误
         Modal.error({
          title: '网络连接失败',
          content: '网络连接失败，请检查网络连接',
          okText: '确定',
        })
      }else if (error.code === 'ECONNABORTED' && error.message.includes('timeout')) {
        // 请求超时错误
        Modal.error({
          title: '请求超时',
          content: '请求已超时20秒，请检查网络连接或稍后再试',
          okText: '确定',
        })
      }
      return Promise.reject(error)
    }
  }
)

const messages = {
  en: require('./common/lang/en'),
  zh: require('./common/lang/zh')
}

const i18n = createI18n({
  legacy: false,
  locale: localStorage.getItem('lang') || 'en', // 设置地区
  messages, // 设置地区信息
})

const app = createApp(App);

app.config.globalProperties.$mitt = new mitt();

app.config.productionTip = false;
app.use(i18n)
app.use(Antd).use(router).mount('#app')
app.use(VueUeditorWrap)